import $ from 'jquery';
import '../../../stylesheets/semantic-theme/definitions/modules/dimmer';
import '../../../stylesheets/semantic-theme/definitions/modules/modal';
import '../../../stylesheets/semantic-theme/definitions/modules/transition';

import browserTestRun from './browser_test';

export default () => {
  $(document).ready(() => {
    $('.ui.modal.getting_started')
      .modal({
        inverted: true,
      })
      .modal('show');

    $('.ui.modal.getting_started .js_modal_close_button').on('click', () => {
      $('.ui.modal.getting_started').modal('hideDimmer');
    });

    browserTestRun();
  });
};
